<div class="header" [ngStyle]="headerStyle">
  <div class="info">
    <img [src]="logoUrl" />

    <div class="reservation">
      <qr-code [value]="reservationUrl" errorCorrectionLevel="L" />
      <span class="cta">Make your reservation here!</span>
    </div>
  </div>
</div>
